export const TEMPLATE_EDITOR_NO_BLOCK_LIMIT = -1;
export const LANDINGPAGE_NAME_MAX_LENGTH = 100;
